import React, { memo, useCallback, useEffect, useRef } from 'react';

import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Input, Select } from '~/components/Form';
import { t } from '~/helpers';
import { validation, validationErrors } from '~/helpers/yupValidations';

import * as S from './styles';

function FormSubitem({ data, visible, sending, close, onForm, statusOptions }) {
  const formRef = useRef(null);

  const initialData = {
    statusobservacaoatendimentoitem: 'L',
    ...data,
  };

  const handleSubmit = useCallback(
    async (values) => {
      try {
        const schema = Yup.object().shape({
          descricaoobservacaoatendimentoitem: Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(255, t('s.geral.validacao.tamanhomaximo').replace('%s', 255)),
          statusobservacaoatendimentoitem: Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio')),
        });

        await validation(schema, values);

        await onForm({
          ...data,
          ...values,
          descricaoobservacaoatendimentoitem: values.descricaoobservacaoatendimentoitem.trim(),
        });
        await close();
      } catch (error) {
        validationErrors(error, formRef);
      }
    },
    [data, onForm, close]
  );

  useEffect(() => {
    if (sending) {
      formRef.current.submitForm();
    }
  }, [sending]);

  if (!visible) {
    return <div />;
  }

  return (
    <S.Wrapper ref={formRef} initialData={initialData} onSubmit={handleSubmit}>
      <Input
        name="descricaoobservacaoatendimentoitem"
        label={t('s.cadastro.pitstop.descricaoobservacao')}
        inputProps={{ maxLength: 255 }}
      />

      <Select
        name="statusobservacaoatendimentoitem"
        label={t('s.cadastro.pitstop.statusobservacao')}
        options={statusOptions}
      />
    </S.Wrapper>
  );
}

FormSubitem.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  close: PropTypes.func.isRequired,
  onForm: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
  visible: PropTypes.bool.isRequired,
  statusOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
};

FormSubitem.defaultProps = {
  data: {},
  statusOptions: [],
};

export default memo(FormSubitem);
